import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { finalize, tap } from 'rxjs/operators';
// import { LoggingApiService } from '@app/services/logging-api.service';
import { LoggingApiService } from '../services/logging-api.service';
import { AuthService } from '../services/auth.service';
import { StatusEnum } from '../models/status-enum';


@Injectable()
export class LoggingInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService, private logger: LoggingApiService) { }


  private getUrlPath(req: HttpRequest<any>, path: string): string {
    if (path.includes('ReportData')) {
      const reportId = req.body.reportid;
      path = `${path}/${reportId}`;
    }
    return path;
  }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const startTime = Date.now();
    let status: StatusEnum;
    let statusCode: number;
    const method = req.method.includes('POST') ? 'POST' : 'GET';
    const urlParts = req.urlWithParams.split('?');
    const path = this.getUrlPath(req, urlParts[0]);
    const user = this.authService.getTokenEmail();
    this.logDetails('intercept', 'Request', method, startTime, path, urlParts[1], StatusEnum.NotSet, null, null);

    return next.handle(req)
      .pipe(
        tap(
          event => {
            status = StatusEnum.NotSet;
            if (event instanceof HttpResponse) {
              status = StatusEnum.Success;
              statusCode = event.status;
            }
          },
          error => {
            status = StatusEnum.Fail;
            if (error instanceof HttpErrorResponse) {
              statusCode = error.status;
            }
          }
        ),
        finalize(() => {
          this.logDetails('intercept', 'Response', method, startTime, path, urlParts[1], status, statusCode, Date.now());
        })
      );
  }

  private logDetails(appMethod: string, type: 'Request' | 'Response', method: 'GET' | 'POST',
                     startTime: number, url: string, queryString: string,
                     status: StatusEnum, statusCode?: number, end?: number) {

      if (status === StatusEnum.Fail) {
      this.logger.error('logging-interceptor', appMethod, type, method, startTime, url, queryString, statusCode, end);
      } else {
      this.logger.info('logging-interceptor', appMethod, type, method, startTime, url, queryString, statusCode, end);
      }
  }
}
